import Vue from "vue";
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import {VclTable} from 'vue-content-loading';

const UploadDocuments = _ => import(/* webpackChunkName: "js/split/UploadDocuments"*/'@/components/views/home/young/register/partials/UploadDocuments');
const Biographical = _ => import(/* webpackChunkName: "js/split/Biographical", webpackPreload: true */'@/components/views/home/young/register/partials/Biographical');
const GeneralData = _ => import(/* webpackChunkName: "js/split/GeneralData", webpackPreload: true */ '@/components/views/home/young/register/partials/GeneralData');
const GeneralContact = _ => import(/* webpackChunkName: "js/split/GeneralContact", webpackPreload: true */ '@/components/views/home/young/register/partials/GeneralContact');
const AreasOfInterest = _ => import(/* webpackChunkName: "js/split/AreasOfInterest"*/'@/components/views/home/young/register/partials/AreasOfInterest');
const CustomMap = _ => import(/* webpackChunkName: "js/split/CustomMap"*/'@/components/views/home/young/register/partials/CustomMap');

const ConfirmRegister = _ => import(/* webpackChunkName: "js/split/ConfirmRegister"*/'@/components/views/home/young/register/partials/ConfirmRegister');
const RelationShipYoungWithAdvisor = _ => import(/* webpackChunkName: "js/split/RelationShipYoungWithAdvisor", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/RelationShipYoungWithAdvisor');
const FormCompleteProfile = _ => import(/* webpackChunkName: "js/split/FormCompleteProfile", webpackPreload: true */'@/components/views/home/young/register/FormCompleteProfile');

import ActionStep from '@/components/views/home/young/register/partials/ActionsSteps';
import UploadDocument from '@/utils/UploadDocument';

export const completeProfileMix = {
	components: {
		Biographical,
		GeneralData,
		GeneralContact,
		AreasOfInterest,
		UploadDocuments,
		CustomMap,
		ConfirmRegister,
		RelationShipYoungWithAdvisor,
		FormCompleteProfile,
		UploadDocument,
		VclTable,
		ActionStep
	},
	data() {

		var checkIsNumber = (rule, value, callback) => {
			let minLenght = 0;
			let maxLenght = 3;
			if (value) {
				if (value.toString().length < minLenght || value.toString().length > maxLenght) {
					callback(new Error(`La longitud debe ser de ${minLenght} a ${maxLenght} caracteres.`));
				}
			}
			callback();
		};
		var checkIsNumberTwo = (rule, value, callback) => {
			let minLenght = 0;
			let maxLenght = 3;

			let min = 0;
			let max = 100;

			if (value) {
				if (value.toString().length < minLenght || value.toString().length > maxLenght) {
					callback(new Error(`La longitud debe ser de ${minLenght} a ${maxLenght} caracteres.`));
				}
				let valueAlias = parseInt(value);
				if (valueAlias < min || valueAlias > max) {
					callback(new Error(`La valor debe ser de ${min} a ${max} .`));
				}
			}
			callback();
		};


		return {
			rules: {
				'a_fellow.person.numberChildren': [
					{required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']},
					{validator: checkIsNumber, trigger: ['blur', 'change']}
				],
				'a_fellow.person.numberOfTimesYouHaveLeftTheCountry': [
					{required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']},
					{validator: checkIsNumber, trigger: ['blur', 'change']}
				],
				'a_fellow.person.amountOtherHouseHold': [
					{required: true, message: 'Este campo es obligatorio', trigger: ['blur', 'change']},
					{validator: checkIsNumberTwo, trigger: ['blur', 'change']}
				],
			},
			show: false
		}
	},

	computed: {
		...mapState([
			'route'
		]),
		...mapGetters('young', {
			catalogs: 'catalogs',
			form: 'form',
			loadingCatalog: 'loadingCatalog',
			step: 'step',
			alias_areas_of_interest: 'alias_areas_of_interest',
			interest_many: 'interest_many',
			isCompleted: 'isCompleted',
			loadedProfile: 'loadedProfile',
			infoPerson: 'person'
		}),
		...mapGetters(["userFullName", "cat_profile_id"]),
		...mapGetters("loading", ["message", "status"]),
		...mapGetters('young', {
			totalOffline: 'totalOffline'
		}),
		...mapGetters('progress', [
			'progressBar'
		]),
	},
	methods: {
		...mapMutations('young', {
			clear: "clear",
			clearFilters: "clearFilters",
			clearSortable: "clearSortable",

			nextStep: "nextStep",
			setStep: "setStep",
			before: "before",
			fetchSingleSuccess: "fetchSingleSuccess"
		}),
		...mapActions('young', {
			fetchSigle: "fetchSigle",
			storeSave: "storeSave",
			initService: "initService"
		}),


		beforeAlias() {
			this.before();
		},
		clearAlias() {
			this.clear();
			setTimeout(() => {
				//this.$refs['form'].resetFields();
			}, 500);
		},

		submitForm(status) {


			this.$refs['form'].validate((valid, validateData) => {
				if (valid) {
					this.saveFormService(status);

				} else {
					this.$store.dispatch('notifications/error', {msg: 'Debe completar todos los campos obligatorios y/o revisar la información capturada'}, {root: true});
				}
			});
		},
		validatePhones() {
			let response = false;
			if (this.form.a_fellow.person && this.form.a_fellow.person.contact_phones) {

				let phones = this.form.a_fellow.person.contact_phones;

				if (phones.length > 0) {

					phones.forEach(phone => {
						if (phone.phone && phone.phone.trim() != '') {
							response = true;
						}
					});

				} else {
					response = false;
				}
			} else {
				response = false;
			}
			return response;
		},

		validateDocuments() {
			let response = true;
			if (this.form.a_fellow && this.form.a_fellow.person && this.form.a_fellow.person.documents) {

				let documents = this.form.a_fellow.person.documents;

				if (documents.length > 0) {

					documents.forEach(item => {
						if (!item.id && item.cat_document_type_id != 4) {
							response = false;
						}
					});

				} else {
					response = false;
				}

			} else {
				response = false;
			}
			return response;
		},
		validateLocation() {
			let response = false;
			if (this.form.a_fellow && this.form.a_fellow.person && this.form.a_fellow.person.location) {

				if (this.form.a_fellow.person.location.id) {
					response = true;
				}
			} else {
				response = false;
			}
			return response;
		},
		showLoading(msg) {
			this.$store.dispatch(
				"loading/spinner",
				{msg: msg, status: true},
				{root: true}
			);
		},
		hideLoading() {
			this.$store.dispatch("loading/spinner", {}, {root: true});
		},
		serviceFormStore(status) {


			let _requestForm = Object.assign({}, this.form.a_fellow.person);


			this.showLoading('Guardando datos');


			const options = {
				method: 'POST',
				data: {
					people: _requestForm,
					complete: status ? 1 : 0,
					step: this.step
				},
				url: '/api/young/complete-profile'
			};
			window.axios(options).then(response => {
				this.hideLoading();
				if (response.data.success) {
					//this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
					this.fetchSingleSuccess(response.data);
					this.setInterest();
					if (!status) {
						this.nextStep();
					}
					if (status) {
						this.$store.dispatch('notifications/ok', {msg: 'Su información se envió a validación.'}, {root: true});
						this.$router.push('/inicio');
						setTimeout(() => {
							location.reload();
						}, 2000);
					}

				}
				else {
					this.$store.dispatch('notifications/error', {msg: 'No se pudo guardar la solicitud.'}, {root: true});
				}
			}).catch(error => {
				this.hideLoading();
				this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción.'}, {root: true});
			});

		},

		validateAreasOfInterest() {
			let response = false;
			let count = 0;
			if (this.alias_areas_of_interest) {
				Object.keys(this.alias_areas_of_interest).forEach((key) => {
					if (this.alias_areas_of_interest[key].check === true) {
						count++;
					}
				});
				if (count > 0) {
					response = true;
				}

			}
			return response;
		},
		saveFormService(status) {

			if (this.step == 0 && !this.validateAreasOfInterest()) {
				this.$store.dispatch('notifications/warning', {msg: 'Por favor, seleccione al menos una área de interés'}, {root: true});
				return false;
			}

			if (this.step == 3 && !this.validatePhones()) {
				this.$store.dispatch('notifications/warning', {msg: 'Por favor, complete los al menos un teléfono de contacto'}, {root: true});
				return false;
			}


			if (this.step == 3) {

				let countPhone = [];
				if (this.form.a_fellow.person && this.form.a_fellow.person.family_members) {
					let family_members = this.form.a_fellow.person.family_members;
					if (family_members.length > 0) {

						family_members.forEach(item => {
							let checkOne = true;
							item.person.contact_phones.forEach(phone => {
								if (phone.phone && phone.phone.trim() != '' && checkOne === true) {
									countPhone.push(1);
									checkOne = false;
								}
							});
						});

						let totalPhones = family_members.length;
						if (countPhone < totalPhones) {
							this.$store.dispatch('notifications/warning', {
								msg: 'Por favor, complete  al menos un teléfono de contacto de cada familiar'
							}, {
								root: true
							});
							return false;
						}


					} else {
						this.$store.dispatch('notifications/warning', {
							msg: 'Por favor, complete los al menos un familiar de contacto'
						}, {
							root: true
						});
						return false;
					}
				} else {
					this.$store.dispatch('notifications/warning', {
						msg: 'Por favor, complete los al menos un familiar de contacto'
					}, {
						root: true
					});
					return false;
				}


			}
			if (this.step == 4 && !this.validateDocuments()) {
				this.$store.dispatch('notifications/warning', {
					msg: 'Es necesario que suba toda la documentación que se le solicita para continuar'
				}, {root: true});
				return false;
			}

			/*if (this.step == 5 && !this.validateLocation()) {
				this.$store.dispatch('notifications/warning', {
					msg: 'Por favor, ubique con el marcador  la ubicación de su hogar'}, {root: true});
				return false;
			}*/


			this.serviceFormStore(status);


		},
		setInterest() {
			this.show = false;
			if (this.catalogs.catAreasOfInterest) {
				this.catalogs.catAreasOfInterest.forEach((b) => {
					Vue.set(this.alias_areas_of_interest, b.id, {
						check: false
					});
					if (this.interest_many) {
						this.interest_many.forEach((item) => {
							if (item.cat_area_interest_id == b.id) {
								this.alias_areas_of_interest[b.id].check = true;
							}
						});

					}

				});
				this.show = true;
			}
		},
		iniOnlyProfile() {

			let _this = this;
			//if (this.infoPerson && this.infoPerson.id) {
				return this.fetchSigle().then((res) => {
					_this.setInterest();
				}).catch((err) => {
				});
			//}


		},
		initInfoYong(yongHashId){

		
			let _this = this;
			this.show = false;

			this.initService().then(() => {
				return this.fetchSigle({
					yongHashId: yongHashId
				}).then((res) => {
					_this.setInterest();
				}).catch((err) => {

				});
			});

		},
		init() {
			let _this = this;
			this.show = false;

			this.initService().then(() => {
				/*return this.fetchSigle().then((res) => {
					_this.setInterest();
				}).catch((err) => {
				});*/
				_this.setInterest();
			});
		},
		checkLetter() {
			let check = true;
			if (this.form && this.form.a_fellow && this.form.a_fellow.person && this.form.a_fellow.person.documents) {
				this.form.a_fellow.person.documents.forEach((item) => {
					if (item.cat_document_type_id == 6 && item.id) {
						check = false;
					}
				});

			}
			return check;
		},
		addFileCommitmenLetter(fileInfo) {

			this.$store.dispatch('loading/spinner', {msg: 'Cargando archivo...', status: true}, {root: true});

			var data = {
				file_id: fileInfo.id,
				cat_document_type_id: 6,
				id: null
			};

			window.axios.post(`/api/young/save-document`, data)
				.then((response) => {
					this.$store.dispatch('loading/spinner', {}, {root: true});
					const parsedResponse = response.data;
					if (parsedResponse && parsedResponse.success == true) {
						this.$store.dispatch('notifications/ok', {msg: parsedResponse.message}, {root: true});
						setTimeout(() => {
							location.reload();
						}, 1000);
					}
				})
				.catch((err) => {
					this.$store.dispatch('loading/spinner', {}, {root: true});
					let msg = 'No se pudo completar la acción';
					if (err.response &&
						err.response.data &&
						err.response.data.message
						&& err.response.status == 400) {
						msg = err.response.data.message;
					}
					this.$store.dispatch('notifications/error', {msg: msg}, {root: true});

				});


		},
	},


};
